import { render, staticRenderFns } from "./DataTablePagination.vue?vue&type=template&id=5fa19052&scoped=true"
import script from "./DataTablePagination.vue?vue&type=script&lang=ts"
export * from "./DataTablePagination.vue?vue&type=script&lang=ts"
import style0 from "./DataTablePagination.vue?vue&type=style&index=0&id=5fa19052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa19052",
  null
  
)

export default component.exports